import { CollectionEntity } from "@busy-human/gearbox";
export var ZohoTokens;
(function (ZohoTokens) {
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return {
                name: '',
                clientId: null,
                clientSecret: null,
                refreshToken: null,
                accessToken: null,
                grantToken: null,
                expiresIn: "",
                redirectURL: null
            };
        }
    }
    ZohoTokens.CollectionClass = CollectionClass;
    ZohoTokens.Collection = new CollectionClass({ path: "/zoho-tokens" });
})(ZohoTokens || (ZohoTokens = {}));
//# sourceMappingURL=index.js.map